document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.wed10-tab1, .wed10-tab2');
    const buttons = document.querySelectorAll('.wed10-buttons h6');
    function switchTab(index) {
        tabs.forEach(tab => tab.style.display = 'none');
        buttons.forEach(btn => btn.style.borderBottom = '2px solid #B9B9B9');
        tabs[index].style.display = 'flex';
        buttons[index].style.borderBottom = '2px solid #4A4A4A';
    }
    switchTab(0);
    buttons.forEach((button, index) => {
        button.addEventListener('click', () => switchTab(index));
    });
});